import BasePreferencesProvider from './base.provider';

export default class LocalStoragePreferencesProvider extends BasePreferencesProvider {
  static getData() {
    let data = localStorage.getItem('preferences');

    if (data) {
      data = JSON.parse(data);
    } else {
      data = {};
    }

    return data;
  }

  static setData(data) {
    localStorage.setItem('preferences', JSON.stringify(data));
  }

  static async getMap() {
    return this.getData();
  }

  static async setKey(key, value) {
    const config = this.getData();

    config[key] = value;

    this.setData(config);
  }
}
